import { render, staticRenderFns } from "./HeaderSearchPopup.vue?vue&type=template&id=3899ba8e"
import script from "./HeaderSearchPopup.vue?vue&type=script&lang=js"
export * from "./HeaderSearchPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports